const REFRESH_SBR_MUNTAZIM_DASHBOARD = 'REFRESH_SBR_MUNTAZIM_DASHBOARD';
const ON_SMS_RECEIVED = 'ON_SMS_RECEIVED<PHONE_NO>';
const ON_SMS_STATUS_UPDATED = 'ON_SMS_STATUS_UPDATED<PHONE_NO>';
const REFRESH_REQUEST_DASHBOARD = 'REFRESH_REQUEST_DASHBOARD';
const UPDATE_MESSENGER_USERS_LIST = "UPDATE_MESSENGER_USERS_LIST";
const ON_INCOMING_SMS_RECEIVED = "ON_INCOMING_SMS_RECEIVED";
const ON_NEW_CALL_SELLER = 'ON_NEW_CALL_SELLER_<SBR_ID>';
const ASSIGN_REQUEST_TO_MANAGER =  "ASSIGN_REQUEST_TO_MANAGER<MANAGER_USER_ID>"; 
const UNASSIGN_REQUEST_FROM_MANAGER =  "UNASSIGN_REQUEST_FROM_MANAGER<MANAGER_USER_ID>"; 
const UPDATE_MANAGER_ASSIGNED_REQUEST =  "UPDATE_MANAGER_ASSIGNED_REQUEST<MANAGER_USER_ID>"; 
const SEND_INCOMING_MESSAGE_TO_AM_DASHBOARD = "SEND_INCOMING_MESSAGE_TO_AM_DASHBOARD<MANAGER_USER_ID>";
const ON_NEW_CALL_BUYER = 'ON_NEW_CALL_BUYER_<SBR_ID>';
const REFRESH_CALL_HISTORY_FOR_SBR = 'REFRESH_CALL_HISTORY_FOR_SBR_<SBR_ID>';
const ON_NEW_SBR_NOTE_RECEIVED = "ON_NEW_SBR_NOTE_RECEIVED<SBR_ID>" 


module.exports = {
    REFRESH_SBR_MUNTAZIM_DASHBOARD,
    ON_SMS_RECEIVED,
    ON_SMS_STATUS_UPDATED,
    ON_INCOMING_SMS_RECEIVED,
    REFRESH_REQUEST_DASHBOARD,
    UPDATE_MESSENGER_USERS_LIST,
    ON_NEW_CALL_SELLER,
    ASSIGN_REQUEST_TO_MANAGER,
    UNASSIGN_REQUEST_FROM_MANAGER,
    UPDATE_MANAGER_ASSIGNED_REQUEST,
    SEND_INCOMING_MESSAGE_TO_AM_DASHBOARD,
    ON_NEW_CALL_BUYER,
    REFRESH_CALL_HISTORY_FOR_SBR,
    ON_NEW_SBR_NOTE_RECEIVED
}